import { render } from "./UploadDialog.vue?vue&type=template&id=3a486ca2&ts=true"
import script from "./UploadDialog.vue?vue&type=script&lang=ts"
export * from "./UploadDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__